import type { UserDetails } from '@/types/reports'
import {
  MessageCircleWarning,
  CalendarX2,
  ClockAlert,
  OctagonAlert
} from 'lucide-vue-next'

export function useReportHelpers() {
  const getUserInitials = (userDetails: UserDetails): string => {
    const first = userDetails.first_name?.charAt(0)?.toUpperCase() || ''
    const last = userDetails.last_name?.charAt(0)?.toUpperCase() || ''
    return first + last
  }

  const getStatusClass = (status: string): string => {
    switch (status) {
      case 'APPROVED':
        return 'bg-blue-100 text-blue-800'
      case 'PENDING':
        return 'bg-yellow-100 text-yellow-800'
      case 'REJECTED':
        return 'bg-gray-100 text-gray-800'
      case 'REVOKED':
        return 'bg-purple-100 text-purple-800'
      case 'UNDER_REVIEW':
        return 'bg-purple-100 text-purple-800'
      default:
        return 'bg-gray-100 text-gray-800'
    }
  }

  const reasonIcons = {
    UNPROFESSIONAL: MessageCircleWarning,
    COMMUNICATION: MessageCircleWarning,
    ATTENDANCE: CalendarX2,
    PERFORMANCE: ClockAlert,
    OTHER: OctagonAlert
  }

  const getReasonIcon = (reason: string) => {
    return reasonIcons[reason as keyof typeof reasonIcons] || OctagonAlert
  }

  return {
    getUserInitials,
    getStatusClass,
    getReasonIcon,
    reasonIcons
  }
}